import { ReducersRegistry } from "@grandvisionhq/state";
import { reducer } from "./state/state/reducer.js";
import { ctaLabelSelectorProps, isDynamicStep } from "./state/state/state.js";
import * as actions from "./state/state/actions.js";
import * as selectors from "./state/state/selectors.js";
import { useConfiguratorContext } from "./Context/Context/ConfiguratorContext.js";
import { ConfiguratorContainer } from "./components/Configurator/components/Configurator/ConfiguratorContainer.js";
import { ConnectedStepFormContainer, StepFormContainer } from "./components/StepForm/components/StepForm/StepFormContainer.js";
import { default as default2 } from "./components/ConfiguratorStep/components/ConfiguratorStepTitleAndDescription/components/ConfiguratorStep/components/ConfiguratorStepTitleAndDescription/ConfiguratorStepTitleAndDescriptionContainer.js";
ReducersRegistry.register("configurators", reducer);
export {
  actions as Actions,
  ConfiguratorContainer as Configurator,
  default2 as ConfiguratorStepTitleAndDescription,
  ConnectedStepFormContainer as ConnectedStepForm,
  selectors as Selectors,
  StepFormContainer as StepForm,
  ctaLabelSelectorProps,
  isDynamicStep,
  useConfiguratorContext
};
//# sourceMappingURL=index.js.map
